import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = ['Services', 'How It Works', 'About', 'Service Area', 'Reviews', 'Contact'];
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, link: string) => {
    e.preventDefault();
    const id = link.toLowerCase().replace(/\s+/g, '-');
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    setMobileMenuOpen(false);
  };
  return <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${scrolled ? 'bg-brand-black border-b-2 border-brand-green py-3' : 'bg-transparent py-5'}`} data-id="element-195">
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-196">
        <div className="flex items-center" data-id="element-197">
          <img src="https://cdn.magicpatterns.com/uploads/iTHV1zi5LbUMvL5bFz6T1i/pestco.webp" alt="Ultimate Pest Co Logo" className="h-[44px] w-[44px] md:h-[60px] md:w-[60px] object-contain animate-glow-pulse bg-black rounded-full" data-id="element-198" />
        </div>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center space-x-8" data-id="element-199">
          <div className="flex space-x-8" data-id="element-200">
            {navLinks.map(link => <a key={link} href={`#${link.toLowerCase().replace(/\s+/g, '-')}`} onClick={e => handleNavClick(e, link)} className="font-condensed uppercase tracking-wider text-white hover:text-brand-green transition-colors text-lg" data-id="element-201">
                {link}
              </a>)}
          </div>
          <a href="#contact" onClick={e => handleNavClick(e, 'Contact')} className="bg-brand-green text-black font-bold px-6 py-3 clip-parallelogram hover:bg-white transition-colors font-condensed uppercase tracking-wide text-lg" data-id="element-202">
            Get a Quote
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-white hover:text-brand-green" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-203">
          {mobileMenuOpen ? <X size={32} data-id="element-204" /> : <Menu size={32} data-id="element-205" />}
        </button>
      </div>

      {/* Mobile Nav Dropdown */}
      {mobileMenuOpen && <div className="lg:hidden absolute top-full left-0 w-full bg-brand-black border-b border-brand-green/30 py-4 px-6 flex flex-col space-y-4 shadow-xl" data-id="element-206">
          {navLinks.map(link => <a key={link} href={`#${link.toLowerCase().replace(/\s+/g, '-')}`} className="font-condensed uppercase tracking-wider text-white text-xl py-2 border-b border-white/10" onClick={e => handleNavClick(e, link)} data-id="element-207">
              {link}
            </a>)}
          <a href="#contact" onClick={e => handleNavClick(e, 'Contact')} className="bg-brand-green text-black font-bold px-6 py-4 clip-parallelogram mt-4 font-condensed uppercase tracking-wide text-xl w-full text-center block" data-id="element-208">
            Get a Quote
          </a>
        </div>}
    </nav>;
}